import { Switch } from '@mantine/core';
import { ChangeEventHandler } from 'react';
import classes from './StatusSwitch.module.css';
import './style.css';

type TStatusSwitchProps = {
	active?: boolean;
	onChange?:
		| ChangeEventHandler<HTMLInputElement>
		| undefined;
	inActiveLabel: string;
	activeLabel: string;
	readonly?: boolean;
	disabled?: boolean;
};

export const StatusSwitch = ({
	active,
	activeLabel,
	inActiveLabel,
	onChange,
	readonly,
}: TStatusSwitchProps) => {
	return (
		<Switch
			size="md"
			checked={active}
			onLabel={activeLabel}
			offLabel={inActiveLabel}
			onChange={readonly ? undefined : onChange}
			classNames={{
				root: classes.root,
				track: classes.track,
				thumb: classes.thumb,
				trackLabel: classes.trackLabel,
			}}
		/>
	);
};
